module.exports = __webpack_public_path__ + "static/sp_checkout_thumbnail-21b9b5fe4fdfe039a4415135722b8f6c.jpg";